var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M14 2.5Q14 10 21.5 10Q14 10 14 17.5Q14 10 6.5 10Q14 10 14 2.5Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.5 13.5Q6.5 17.5 10.5 17.5Q6.5 17.5 6.5 21.5Q6.5 17.5 2.5 17.5Q6.5 17.5 6.5 13.5Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }